import { styled } from '@mui/material'

export const StyledForm = styled('form')(({ active, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
  height: 'fit-content',
}))
